import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "bulkActions", "selectedCount"]

  connect() {
    this.updateSelectedCount()
  }

  checkboxChanged() {
    this.updateSelectedCount()
  }

  toggleCheckbox(event) {
    // Don't toggle if the click was on the checkbox itself
    if (event.target.classList.contains('discovery-checkbox')) {
      return
    }

    const discoveryId = event.currentTarget.dataset.discoveryId
    const checkbox = document.getElementById(`discovery-checkbox-${discoveryId}`)

    if (checkbox) {
      checkbox.checked = !checkbox.checked
      this.updateSelectedCount()
    }
  }

  checkboxClicked(event) {
    // Prevent the image click handler from toggling the checkbox again
    event.stopPropagation()
    this.updateSelectedCount()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  updateSelectedCount() {
    const checkboxes = document.querySelectorAll('.discovery-checkbox')
    const checkedBoxes = Array.from(checkboxes).filter(box => box.checked)
    const count = checkedBoxes.length

    if (count > 0) {
      this.bulkActionsTarget.classList.remove("is-hidden")
      this.selectedCountTarget.textContent = count
    } else {
      this.bulkActionsTarget.classList.add("is-hidden")
    }
  }

  makePublic(event) {
    event.preventDefault()
    this.submitBulkAction('make_public')
  }

  makePrivate(event) {
    event.preventDefault()
    this.submitBulkAction('make_private')
  }

  delete(event) {
    event.preventDefault()
    if (confirm("Are you sure you want to delete these discoveries?")) {
      this.submitBulkAction('delete')
    }
  }

  submitBulkAction(action) {
    const actionInput = document.createElement('input')
    actionInput.type = 'hidden'
    actionInput.name = 'action_type'
    actionInput.value = action

    this.element.appendChild(actionInput)
    this.element.requestSubmit()
  }
}
